import { useEffect } from "react";
import { logout } from "../../service/AuthService";
import { useDispatch } from "react-redux";
import { clearUser } from "../../store/userSlice";

const Logout = () => {
    const dispatch = useDispatch();
    
    useEffect(() => {
        logout();
        dispatch(clearUser());
        localStorage.clear();
        window.location.href = '/';
    }, [dispatch]); 

    return null; // No UI is rendered for this component
};

export default Logout;